module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffDeptName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.staffName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请日期")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.registerDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("拟录用人员基本信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("拟录用人员姓名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.luyongPeople))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("出生年月")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.birthday))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("性别")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.sex))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("专业")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.specialty))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("学历")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.education))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("毕业院校")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.graduateSchool))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("证书情况")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.carInfo))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("拟录用人员信息确认")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("拟聘职务")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.job))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("拟聘职级")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.positionLevel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("预计到岗时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.toDate))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("实际到岗时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.toRealDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("试用工资")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tryMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("试用期限")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tryMonth))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正工资")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.formalMoney))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("转正工资模式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.tryModel))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("录用人员所在部门经理")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.leaderName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("工作地点")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.workAddress))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("部门评价")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.jobRequire))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-654808aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/hr/personEmploy.vue
// module id = Kz4g
// module chunks = 0